// @flow
export const API_BASE_URL = process.env.REACT_APP_OCTO_BASE ? `${process.env.REACT_APP_OCTO_BASE}/link` : 'http://localhost:8081/link';

export const SENTRY_DSN = 'https://49dfed062d3a42b29aa36a300ae51490@o488647.ingest.sentry.io/5700189';
